<template>
  <section class="section --margin">
    <div :class="['section__flex', { '--reverse': reverse }]">
      <Image v-if="content.image" :source="content.image" class="img__ratio section__image" />
      <div class="section__half">
        <p v-if="content.header" class="text__quote">{{ content.header }}</p>
        <h2>{{ content.title }}</h2>
        <p class="paragraph mt-16">{{ content.description }}</p>
        <DynamicLink :button="content.button" :link="link" :page="page" class="mt-30" />
      </div>
    </div>
  </section>
</template>

<script>
import Image from '@/components/global/Image.vue'
import DynamicLink from '@/components/small/DynamicLink.vue'

export default {
  name: 'ImageCTASection',
  components: { DynamicLink, Image },
  props: {
    content: {
      type: Object,
      required: true,
    },
    link: {
      type: String,
      default: '',
    },
    page: {
      type: String,
      default: '',
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
